import { createStatsProSlice } from '../statsProSlice';
import { DATA_TYPE } from 'widgets/statspro/js/components/common/config/data-type';

/**
 * @typedef {StatsProState & {
 *      nav: StatsProNavState & {
 *           category: string
 *      },
 *      requests: any[],
 *      data: any[]
 * }
 * } StatComparisonState
 */

/**
 * @type {StatComparisonState}
 */
const initialState = {
    nav: {
        category: 'Key Stats',
        season: {
            id: -1
        }
    },
    dataType: {
        type: DATA_TYPE.BENCHMARKED_AVERAGES
    },
    requests: [],
    data: []
};

export const statComparisonSlice = createStatsProSlice({
    name: 'stat-comparison',
    initialState,
    mergeKeys: ['nav', 'dataType']
});

export const statComparisonReducer = statComparisonSlice.reducer;
export const statComparisonActions = statComparisonSlice.actions;
